import React, { useState } from "react";
import { projectFirestore, timestamp } from "../../firebase/config";
import { useParams } from "react-router-dom";

export const TaskForm = () => {
  const { id } = useParams();
  const [NewTask, setNewTask] = useState('');
  const notes = 'add something here'

  const submitTask = (e) => {
    e.preventDefault();
    projectFirestore.collection("projects").doc(id).collection("tasks").add({
      title: NewTask,
      createdAt: timestamp.fromDate(new Date()),
      notes,
      status: false
    });
    setNewTask("");
  };

  return (
    <div className="my-6">
      <h2 className="font-bold mb-2">Add New Task</h2>
      <form onSubmit={submitTask}>
        <input
          type="text"
          className="border-2 p-2 b-slate-400 rounded-md mr-2 focus:border-indigo-600 "
          onChange={(e) => setNewTask(e.target.value)}
          value={NewTask}
          placeholder="Task Title"
        />
        <button 
        className="inline-flex justify-center py-2 px-4 shadow-sm border-indigo-600 border-2 text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        type="submit">Add Task</button>
      </form>
    </div>
  );
};
